<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickSave)">

          <!-- I.T.S. Team -->
          <vx-card title="I.T.S. Team" class="mb-6">
            <div v-for="(pair, i) in itsPairs" :key="i">
              <div class="vx-row mb-4">
                <div class="vx-col md:w-1/2 w-full">
                  <small class="font-semibold">{{ pair[0].label }}</small>
                  <vs-input v-model="form[pair[0].name]" class="w-full mt-1" placeholder="Name" />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <small class="font-semibold">{{ pair[1].label }}</small>
                  <vs-input v-model="form[pair[1].name]" class="w-full mt-1" placeholder="Name" />
                </div>
              </div>
              <hr v-if="i < itsPairs.length - 1" class="mb-4" style="opacity: 0.15;" />
            </div>
          </vx-card>

          <!-- ECD Settings -->
          <vx-card title="ECD Settings" class="mb-6">
            <div class="vx-row">
              <div class="vx-col w-full mb-4">
                <small>Production Samples Comment</small>
                <vs-textarea v-model="form.ecd_supply_production_samples_comment" height="80px" class="w-full mb-0" />
              </div>
              <div class="vx-col w-full mb-4">
                <small>ECD Raw Batch No. Comment</small>
                <vs-textarea v-model="form.ecd_supply_raw_batch_no_comment" height="80px" class="w-full mb-0" />
              </div>
              <div class="vx-col w-full mb-4">
                <small>ECD to Label Comment</small>
                <vs-textarea v-model="form.ecd_supply_ecd_to_label_comment" height="80px" class="w-full mb-0" />
                <small class="text-grey">Use <code>{product_code}</code> to insert the product code into the comment. Use <code>{logo}</code> to display the appropriate certification text (Halal / Kosher) based on the formulation.</small>
              </div>
              <div class="vx-col w-full mb-4">
                <small>Notifications</small>
                <vs-textarea v-model="form.notifications" height="80px" class="w-full mb-0" />
              </div>
            </div>
          </vx-card>

          <div class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import ErrorMessages from '@/mixins/ErrorMessages'
import SuccessMessage from '@/mixins/SuccessMessage'

const ECDSettingsRepository = RepositoryFactory.get('ecd_settings')

const itsPairs = [
  [
    { name: 'head_of_innovations', label: 'I.T.S. Head of Innovations' },
    { name: 'head_of_innovations_deputy', label: 'Deputy' },
  ],
  [
    { name: 'head_of_operations', label: 'I.T.S. Head of Operations' },
    { name: 'head_of_operations_deputy', label: 'Deputy' },
  ],
  [
    { name: 'technical_manager', label: 'I.T.S. Technical Manager' },
    { name: 'technical_manager_deputy', label: 'Deputy' },
  ],
]

export default {
  name: 'ECDSettings',
  mixins: [ErrorMessages, SuccessMessage],
  data() {
    return {
      itsPairs,
      form: {
        head_of_innovations: '',
        head_of_innovations_deputy: '',
        head_of_operations: '',
        head_of_operations_deputy: '',
        technical_manager: '',
        technical_manager_deputy: '',
        ecd_supply_production_samples_comment: '',
        ecd_supply_raw_batch_no_comment: '',
        ecd_supply_ecd_to_label_comment: '',
        notifications: '',
      }
    }
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      this.$vs.loading()
      try {
        const { data } = (await ECDSettingsRepository.getECDSettings()).data
        Object.values(data).forEach(section => {
          section.elements.forEach(el => {
            if (el.name in this.form) {
              this.form[el.name] = el.value || ''
            }
          })
        })
      } catch (error) {
        this.convertAndNotifyError(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    async onClickSave() {
      this.$vs.loading()
      try {
        await ECDSettingsRepository.saveECDSettings({ ...this.form })
        this.showSuccessMessage('ECD settings saved successfully')
      } catch (error) {
        this.convertAndNotifyError(error)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>
